<div *ngIf="showHeaderExport" ttPageHeaderTableTools class="tt-data-table__toolbar-actions">
  <button
    type="button"
    class="tt-filter-icon-btn tt-data-table__export"
    aria-label="Exportovat"
    title="Exportovat"
    [disabled]="financeExportDisabled"
    [attr.aria-busy]="financeExporting ? true : null"
    (click)="exportWorkbook()"
  >
    <app-action-icon name="export"></app-action-icon>
  </button>
</div>
<app-skeleton *ngIf="loading" variant="page" [columns]="5" [rows]="6" label="Načítání financí…"></app-skeleton>
<p *ngIf="error" class="text-sm text-amber-700 dark:text-amber-300 mb-6">{{ error }}</p>

<app-finance-progress-comparison
  *ngIf="!loading && comparison && progressComparison"
  [model]="progressComparison"
  [progressError]="progressSnapshotError"
></app-finance-progress-comparison>

<section *ngIf="!loading && !comparison && !comparisonLoading" class="mb-6 tt-detail-section" aria-labelledby="finance-compare-empty-heading">
  <h2 id="finance-compare-empty-heading" class="tt-detail-section__title mb-0">Srovnání prostavěnosti a plánovaných příjmů</h2>
  <p class="mt-1 mb-3 text-sm text-neutral-500 dark:text-neutral-400">Fyzický pokrok vs. Finanční krytí</p>
  <p class="tt-detail-value">Pro srovnání prostavěnosti a plánu je potřeba importované PPD.</p>
</section>

<section *ngIf="!loading && comparison" class="mb-6 tt-detail-section" aria-labelledby="finance-plan-heading">
  <h2 id="finance-plan-heading" class="tt-detail-section__title">Plán (PPD) vs skutečnost</h2>
  <p *ngIf="workDetailWarning" class="text-sm text-amber-700 dark:text-amber-300 mb-3">{{ workDetailWarning }}</p>
  <div class="flex flex-wrap items-center gap-x-5 gap-y-1 text-xs mb-3">
    <span class="inline-flex items-center gap-2 text-sky-800 dark:text-sky-200">
      <span class="inline-block w-8 h-3 rounded-sm bg-sky-100 dark:bg-sky-950/50 border border-sky-300 dark:border-sky-600" aria-hidden="true"></span>
      Plán (PPD)
    </span>
    <span class="inline-flex items-center gap-2 text-emerald-800 dark:text-emerald-200">
      <span class="inline-block w-8 h-3 rounded-sm bg-emerald-100 dark:bg-emerald-950/40 border border-emerald-400 dark:border-emerald-600" aria-hidden="true"></span>
      Skutečnost
    </span>
  </div>
  <app-data-table
    [columns]="comparisonTableColumns"
    [rows]="comparisonTableRows"
    [trackByFn]="trackComparisonRow"
    [rowClassFn]="comparisonRowClass"
    [clickableRows]="true"
    (rowClick)="onComparisonRowClick($event)"
    [enablePagination]="false"
    [enableExport]="false"
    [enableShowAll]="false"
    [showSummary]="false"
    density="compact"
    variant="surface"
    rowBaseClass="bg-background-tertiary"
    [sourceTotal]="comparisonTableRows.length"
    [totalItems]="comparisonTableRows.length"
  >
    <ng-template appDataTableCell="label" let-row="row">
      <span
        class="inline-flex items-start gap-2 min-w-0 max-w-[14rem] break-words whitespace-normal"
        [ngClass]="labelIndentClass(row)"
        [class.font-semibold]="row.isTotal || row.rowType === 'group'"
        [class.font-medium]="row.rowType === 'listedSum'"
        [class.text-sky-800]="row.kind === 'material' && row.rowType === 'group'"
        [class.dark:text-sky-200]="row.kind === 'material' && row.rowType === 'group'"
        [class.text-emerald-800]="row.kind === 'work' && row.rowType === 'group'"
        [class.dark:text-emerald-200]="row.kind === 'work' && row.rowType === 'group'"
        [class.text-neutral-700]="row.rowType === 'category' || row.rowType === 'line'"
        [class.dark:text-neutral-300]="row.rowType === 'category' || row.rowType === 'line'"
        [class.text-neutral-600]="row.rowType === 'listedSum'"
        [class.dark:text-neutral-400]="row.rowType === 'listedSum'"
      >
        <span
          *ngIf="row.expandable || row.rowType === 'group'"
          class="inline-block w-3 shrink-0 text-neutral-500 dark:text-neutral-400"
          aria-hidden="true"
        >{{ isComparisonRowExpanded(row) ? '▾' : '▸' }}</span>
        <span *ngIf="row.rowType === 'line'" class="inline-block w-3 shrink-0 text-neutral-400" aria-hidden="true">·</span>
        <span class="break-words whitespace-normal">{{ row.label }}</span>
      </span>
    </ng-template>
    <ng-template appDataTableCell="planned" let-row="row">
      <span
        [appCountUp]="formatFinanceKc(row.planned)"
        [appCountUpStatic]="!isFinanceHeadlineRow(row)"
      ></span>
    </ng-template>
    <ng-template appDataTableCell="actual" let-row="row">
      <span
        [appCountUp]="formatFinanceKc(row.actual)"
        [appCountUpStatic]="!isFinanceHeadlineRow(row)"
      ></span>
    </ng-template>
    <ng-template appDataTableCell="variance" let-row="row">
      <span
        [class.text-emerald-700]="row.variance >= 0"
        [class.dark:text-emerald-300]="row.variance >= 0"
        [class.text-red-700]="row.variance < 0"
        [class.dark:text-red-300]="row.variance < 0"
        [class.text-neutral-900]="row.isTotal"
        [class.dark:text-neutral-100]="row.isTotal"
        [appCountUp]="formatFinanceKc(row.variance)"
        [appCountUpStatic]="!isFinanceHeadlineRow(row)"
      ></span>
    </ng-template>
  </app-data-table>
</section>

<app-skeleton *ngIf="comparisonLoading && !comparison" variant="table" [columns]="6" [rows]="6" label="Načítání srovnání PPD…"></app-skeleton>
